import { Dimensions, Platform } from 'react-native';

import { isWebScalingEnabled } from '@/core/services/webScalingConfigService';
import { readViewportMetrics } from '@/core/utils/viewportMetrics';

/**
 * Web shell breakpoint — below this, WebAppLayout uses compact padding / hides sidebar.
 * Feature modules often use 768 (phone); shell uses 1366 for historical layout.
 */
export const BREAKPOINTS = {
  PHONE: 768,
  TABLET: 1024,
  SHELL: 1366,
  /** @deprecated Use BREAKPOINTS.SHELL */
  SMALL: 1366,
  /** @deprecated Use BREAKPOINTS.TABLET */
  MEDIUM: 1024,
} as const;

/**
 * Width used for breakpoint checks.
 * Web: visualViewport.width (zoom-aware). Native: Dimensions window width.
 */
export const getBreakpointWidth = (): number => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const metrics = readViewportMetrics();
    return isWebScalingEnabled()
      ? metrics.visibleWidth
      : metrics.layoutWidth;
  }
  return Dimensions.get('window').width;
};

/** @deprecated Prefer getBreakpointWidth() on web. */
export const getScreenWidth = (): number => {
  return getBreakpointWidth();
};

export const isSmallScreen = (width?: number): boolean => {
  return (width ?? getBreakpointWidth()) < BREAKPOINTS.SHELL;
};

export const isPhoneScreen = (width?: number): boolean => {
  return (width ?? getBreakpointWidth()) < BREAKPOINTS.PHONE;
};

export const isMediumScreen = (width?: number): boolean => {
  const w = width ?? getBreakpointWidth();
  return w >= BREAKPOINTS.PHONE && w < BREAKPOINTS.TABLET;
};

export const isLargeScreen = (width?: number): boolean => {
  return (width ?? getBreakpointWidth()) >= BREAKPOINTS.TABLET;
};

export const getResponsiveValue = <T>(small: T, medium: T, large: T): T => {
  if (isSmallScreen()) {
    return small;
  }
  if (isMediumScreen()) {
    return medium;
  }
  return large;
};
